import React from 'react';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import { GamesSliderCasino } from 'src/domains/casino/webview/CasinoGames/home-games/games-home-view/GamesSlider';
import { GamesHomeWrapper } from 'src/domains/casino/webview/CasinoGames/home-games/games-home-view/GamesHome.style';
import { CasinoBanners } from 'src/domains/casino/webview/CasinoGames/home-games/casino-banners/CasinoBanners';
import { extractUserFirstName } from 'src/domains/casino/utils/utils';
import { GamesGridCasino } from 'src/domains/casino/webview/CasinoGames/home-games/games-home-view/GamesGrid';
import { CollectionSlider } from 'src/domains/casino/webview/CasinoGames/home-games/games-home-view/collection-slider/CollectionSlider';
import { useCommon } from 'src/domains/common/Common';
import { InfiniteScrollWrapper } from 'src/domains/casino/webview/infiniteScrollWrapper/InfiniteScrollWrapper';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { GamesSliderMultiCollection } from 'src/domains/casino/webview/CasinoGames/home-games/games-home-view/GamesSliderMultiCollection';

interface LiveCasinoHomePropsType {
    appCasinoState: AppCasinoState;
}

export const LiveCasinoHome = observer('LiveCasinoHome', (props: LiveCasinoHomePropsType) => {
    const { appCasinoState } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const authorizedUserName = extractUserFirstName(common.session.loggedUserName) ?? '';
    const continuePlayingName = configState.hasContinuePlayingName === true ? authorizedUserName : '';

    return (
        <GamesHomeWrapper variant={configState.componentVariants.casinoVariant}>
            <GamesSliderMultiCollection
                appCasinoState={appCasinoState}
                title={
                    <I18n
                        langKey='casino.home.category.name.continue-playing'
                        defaultText='Continue Playing {userName}'
                        params={{ userName: continuePlayingName }}
                    />
                }
                gameModels={appCasinoState.homeCollections.recentGameModels}
                withoutViewAll={true}
            />
            <GamesSliderCasino
                appCasinoState={appCasinoState}
                title={
                    <I18n
                        langKey='livecasino.home.category.name.popular'
                        defaultText='Popular Games'
                    />
                }
                gameModels={appCasinoState.homeCollections.liveCasinoPopularGames.gameModels}
                onViewAllClick={appCasinoState.homeCollections.liveCasinoPopularGames.redirect}
            />
            <GamesGridCasino
                appCasinoState={appCasinoState}
                title={
                    <I18n
                        langKey='livecasino.home.category.name.new'
                        defaultText='New Games'
                    />
                }
                gameModels={appCasinoState.homeCollections.liveCasinoNewGames.gameModels}
                onViewAllClick={appCasinoState.homeCollections.liveCasinoNewGames.redirect}
            />
            <CollectionSlider
                collection='casino'
                appCasinoState={appCasinoState}
                title={
                    <I18n
                        langKey='livecasino.home.category.name.slots'
                        defaultText='Slot Games'
                    />
                }
                gameModels={appCasinoState.homeCollections.casinoPopularGames.gameModels}
                onViewAllClick={appCasinoState.homeCollections.casinoPopularGames.redirect}
                withoutLikeAndInfo={true}
            />
            <CasinoBanners
                appCasinoState={appCasinoState}
                collection='live-casino'
            />
            <GamesSliderCasino
                appCasinoState={appCasinoState}
                title={
                    <I18n
                        langKey='livecasino.home.category.name.table-games'
                        defaultText='Table Games'
                    />
                }
                gameModels={appCasinoState.homeCollections.casinoTableGames.gameModels}
                onViewAllClick={appCasinoState.homeCollections.casinoTableGames.redirect}
                withoutLikeAndInfo={true}
            />
            <InfiniteScrollWrapper
                initAmount={3}
                increaseAmount={2}
            >
                {appCasinoState.homeCollections.liveCasinoCustomGames.map((collection) => (
                    <GamesGridCasino
                        appCasinoState={appCasinoState}
                        key={collection.categoryModel?.id}
                        title={collection.categoryModel?.name === undefined ? '' : collection.categoryModel.name}
                        gameModels={collection.gameModels}
                        onViewAllClick={collection.redirect}
                    />
                ))}
            </InfiniteScrollWrapper>
        </GamesHomeWrapper>
    );
});
